module.exports = __webpack_public_path__ + "static/comenale-1fbf7922b703e50dca568a75c7d14fc2.png";